import React, { Component } from 'react';
import classnames from 'classnames/bind';
import { bool, string, arrayOf, oneOf, object } from 'prop-types';

import RightSide from './RightSide/RightSide';
import LeftSide from './LeftSide/LeftSide';

import styles from './MediaBanner.css';

const cx = classnames.bind(styles);

class MediaBanner extends Component {
  constructor(props) {
    super(props);

    this.totalSlides = props.slides.length;
    this.slidePages = [null, ...props.slides];
  }

  static propTypes = {
    autoplay: bool,
    className: string,
    colorScheme: oneOf([
      'lb01',
      'lb02',
      'lb03',
      'lb04'
    ]),
    title: string,
    highlighted: string,
    description: string,
    slides: arrayOf(object),
    media: object,
    stepsTitle: string,
    steps: arrayOf(object)
  };

  static defaultProps = {
    autoplay: true,
    colorScheme: 'lb02'
  }

  state = {
    activeSlide: 1,
    isPlaying: false,
    isMobile: false,
    isLandscape: false
  };

  totalSlides = null;
  slidePages = null;

  componentDidMount = () => {
    this.checkWindowSize();
    window.addEventListener('resize', this.checkWindowSize);
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.checkWindowSize);
  }

  checkWindowSize = () => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    if (windowWidth <= 768 && !this.state.isMobile) {
      this.setState({ isMobile: true });
    } else if (windowWidth > 768 && this.state.isMobile) {
      this.setState({
        isMobile: false,
      });
    }

    if (windowHeight > windowWidth && !this.state.isLandscape) {
      this.setState({ isLandscape: true });
    } else if (windowHeight < windowWidth && this.state.isLandscape) {
      this.setState({
        isLandscape: false,
      });
    }
  }

  handleCarousel = ({ currentPage }) => this.setState({ activeSlide: currentPage, isPlaying: false });

  togglePlay = () => this.setState({ isPlaying: !this.state.isPlaying })

  render() {
    const { activeSlide, isPlaying, isMobile, isLandscape } = this.state;
    const {
      autoplay,
      className,
      colorScheme,
      title,
      highlighted,
      description,
      media,
      steps,
      stepsTitle
    } = this.props;

    const hasRightCarousel = steps || this.slidePages[activeSlide].steps && true;
    const commonProps = {
      activeSlide: activeSlide,
      colorScheme: colorScheme,
      handleCarousel: this.handleCarousel,
      totalSlides: this.totalSlides,
      autoplay: autoplay,
      isPlaying: isPlaying
    };

    return (
      <section className={cx('mediaBanner', colorScheme, className)}>
        <div className={styles.purpleBackground} />
        <LeftSide
          title={title || this.slidePages[activeSlide].title}
          highlighted={highlighted || this.slidePages[activeSlide].highlighted}
          description={description || this.slidePages[activeSlide].description}
          stepsTitle={stepsTitle || this.slidePages[activeSlide].stepsTitle}
          steps={steps || this.slidePages[activeSlide].steps}
          withoutCarousel={hasRightCarousel || isMobile || isLandscape}
          {...commonProps}
        />
        <RightSide
          typeB={!!steps}
          mediaSlide={media || this.slidePages[activeSlide]}
          togglePlay={this.togglePlay}
          withCarousel={hasRightCarousel || isMobile || isLandscape}
          {...commonProps}
        />
      </section>
    );
  }
}

export default MediaBanner;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/MediaBanner/MediaBanner.js